<template>
  <div type="card-full" >
    <div v-html="ptc.ptctext"></div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "viewptc",
  data() {
    return {
      ptc: {},
    };
  },
  created(){
      this.getModel()
  },
  methods: {
    async getModel() {
      let data = await request({
        url: "/xmgl/ptc/getptcInfo",
        method: "get",
        params: { ptcid: this.$route.query.ptcid },
      });
      this.ptc = data;
    },
  },
};
</script>